import { Box, Paper, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-premium';
import ByzMuiDataGrid from 'src/components/core-components/mui/data-grid';

interface FluidBalanceGridProps {
  selectedDateData: any;
  isLoading: boolean;
}

export default function FluidBalanceGrid({ selectedDateData, isLoading }: FluidBalanceGridProps) {
  // Saat kolonlarını oluştur
  let hoursColumns = [];
  for (let i = 0; i < 24; i++) {
    if (i < 10) {
      hoursColumns.push({
        field: "h" + i,
        headerName: "0" + i.toString(),
        width: 80,
        editable: true,
      });
      continue;
    }
    hoursColumns.push({
      field: "h" + i,
      headerName: i.toString(),
      width: 80,
      editable: true,
    });
  }

  const trackingColumns: GridColDef[] = [
    {
      field: 'io_type',
      headerName: 'Tip',
      width: 100,
      editable: true,
    },
    {
      field: 'f_name',
      headerName: 'Sıvı Adı',
      width: 100,
      editable: true,
    },
    {
      field: "f_id",
      headerName: "ID",
      width: 50,
      editable: true,
    },
    ...hoursColumns,
  ];

  return (
    <Paper sx={{ p: 2, borderRadius: '16px' }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Çizelge Takip
      </Typography>
      {!isLoading ? (
        <>
          <ByzMuiDataGrid
            columns={trackingColumns}
            rows={selectedDateData?.fluid_balance_list || []}
            whiteGrid={true}
            hideFooter
            autoHeight
            getRowId={(row) => row.f_id}
          />
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-around', 
            alignItems: 'center',
            mt: 2,
            p: 2,
            backgroundColor: 'grey.100',
            borderRadius: '8px'
          }}>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              G. Aldığı Sıvı (ml): <span style={{ color: '#1976d2' }}>{selectedDateData?.day_total_in || 0}</span>
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              G. Çıkardığı Sıvı (ml): <span style={{ color: '#d32f2f' }}>{selectedDateData?.day_total_out || 0}</span>
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              G.Balans: <span style={{ color: '#2e7d32' }}>{selectedDateData?.day_balance || 0}</span>
            </Typography>
          </Box>
        </>
      ) : (
        <Typography>Yükleniyor...</Typography>
      )}
    </Paper>
  );
}
